module.exports = __webpack_public_path__ + "static/media/tela_registro.840f0360.png";